import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';
import moment from "moment";

export class LeaseSearch extends Component {
    static displayName = LeaseSearch.name;

    constructor(props) {
        super(props);
        this.state = {
            searchOptions: { sstatus: 1},
            sregionOptions: [{ label: "Branch", value: "Branch" }, { label: "Headquarters", value: "Headquarters" }, { label: "Independent", value: "Independent" }, { label: "Sublessor", value: "Sublessor" }],
            sstateOptions: [{ label: "AL", value: "AL" },
                { label: "AK", value: "AK" },
                { label: "AZ", value: "AZ" },
                { label: "AR", value: "AR" },
                { label: "CA", value: "CA" },
                { label: "CO", value: "CO" },
                { label: "CT", value: "CT" },
                { label: "DE", value: "DE" },
                { label: "DC", value: "DC" },
                { label: "FL", value: "FL" },
                { label: "GA", value: "GA" },
                { label: "HI", value: "HI" },
                { label: "ID", value: "ID" },
                { label: "IL", value: "IL" },
                { label: "IN", value: "IN" },
                { label: "IA", value: "IA" },
                { label: "KS", value: "KS" },
                { label: "KY", value: "KY" },
                { label: "LA", value: "LA" },
                { label: "ME", value: "ME" },
                { label: "MD", value: "MD" },
                { label: "MA", value: "MA" },
                { label: "MI", value: "MI" },
                { label: "MN", value: "MN" },
                { label: "MS", value: "MS" },
                { label: "MO", value: "MO" },
                { label: "MT", value: "MT" },
                { label: "NE", value: "NE" },
                { label: "NV", value: "NV" },
                { label: "NH", value: "NH" },
                { label: "NJ", value: "NJ" },
                { label: "NM", value: "NM" },
                { label: "NY", value: "NY" },
                { label: "NC", value: "NC" },
                { label: "ND", value: "ND" },
                { label: "OH", value: "OH" },
                { label: "OK", value: "OK" },
                { label: "OR", value: "OR" },
                { label: "PA", value: "PA" },
                { label: "RI", value: "RI" },
                { label: "SC", value: "SC" },
                { label: "SD", value: "SD" },
                { label: "TN", value: "TN" },
                { label: "TX", value: "TX" },
                { label: "UT", value: "UT" },
                { label: "VT", value: "VT" },
                { label: "VA", value: "VA" },
                { label: "WA", value: "WA" },
                { label: "WV", value: "WV" },
                { label: "WI", value: "WI" },
                { label: "WY", value: "WY" }
            ],
            sStatusOptions: [{ label: "Open", value: "1" }, { label: "Closed", value: "2" }]
        }

        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
    }

    Search() {
        localStorage.setItem('searchOptions', JSON.stringify(this.state.searchOptions));
        //How to get - localStorage.getItem();
        window.location.href = '/Lease/ActiveLeases?search=1';
        //window.open('/Lease/ActiveLeases?search=1', '_self');
    }
    render() {
        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Search</h3>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Office/Store #
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="soffice_number"
                                    value={this.state.searchOptions.soffice_number}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.soffice_number = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Type
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <select
                                    options={this.state.sregionOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.s_type = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                    value={this.state.searchOptions.s_type}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.sregionOptions.map(option => {
                                        return (
                                            <option key={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Building Name
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sbuilding_name"
                                    value={this.state.searchOptions.sbuilding_name}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.sbuilding_name = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Street Address
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="saddress"
                                    value={this.state.searchOptions.saddress}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.saddress = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            City
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="scity"
                                    value={this.state.searchOptions.scity}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.scity = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            State
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <select
                                    options={this.state.sstateOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.sstate = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                    value={this.state.searchOptions.sstate}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.sstateOptions.map(option => {
                                        return (
                                            <option key={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Zip
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="szip"
                                    value={this.state.searchOptions.szip}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.szip = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Current Expiration Date Start
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input
                                    type="date"
                                    value={this.state.searchOptions.sced}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.sced = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                    name="sced"
                                    id='sced'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Current Expiration Date End
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input
                                    type="date"
                                    value={this.state.searchOptions.scede}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.scede = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                    name="scede"
                                    id='scede'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Status
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <select
                                    options={this.state.sStatusOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var searchOptionsTemp = this.state.searchOptions;
                                        searchOptionsTemp.sstatus = e.target.value;
                                        this.setState({ searchOptions: searchOptionsTemp });
                                    }}
                                    value={this.state.searchOptions.sstatus}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key='' value="-1"></option>
                                    {this.state.sStatusOptions.map(option => {
                                        return (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            &nbsp;
                        </Col>
                        <Col>
                            <div id="controls" style={{ textAlign: 'left' }}>
                                <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                    this.Search();
                                }} >Search</button>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        );
    }


}
